import React, { useCallback, useState } from 'react'
import { Button } from '@/atoms/Button'
import { GuildSolidIcon } from '@/atoms/Icons/GuildSolidIcon'
import { LabelMD } from '@/atoms/Text'
import { useSafeTrack } from '@/utils/analytics'
import { Translate } from '@/utils/translate/translate-client'
import { GuildCtaSheet } from '@/views/GuildSignupView/GuildCtaSheet'

interface JoinTheGuildButtonProps {
  projectSlug: string
  guid: string
}

export const JoinTheGuildButton: React.FC<JoinTheGuildButtonProps> = ({ projectSlug, guid }) => {
  const [isSheetOpen, setSheetOpen] = useState<boolean>(false)
  const track = useSafeTrack()

  const onCloseSheet = useCallback(() => {
    setSheetOpen(false)
    track('Guild Signup Details Closed', {
      context: 'Guild Membership Early Access Page Details Sheet Closed',
      slug: projectSlug,
      guid: guid,
    })
  }, [track, projectSlug, guid])

  const onButtonClick = useCallback(() => {
    setSheetOpen(true)
    track('Guild Sign Up Clicked', { context: 'Livestream CTA', slug: projectSlug, guid })
  }, [track, projectSlug, guid])

  return (
    <>
      <Button className="min-h-[42px] min-w-[190px] rounded" onClick={onButtonClick} variant="oxide-bright">
        <div className="mx-auto flex flex-row justify-center">
          <GuildSolidIcon color1="gray-950" size={16} className="mr-1" />
          <LabelMD color="gray-950" weight="bold">
            <Translate ns="livestream" i18nKey="joinTheGuild">
              Join the Guild
            </Translate>
          </LabelMD>
        </div>
      </Button>
      <div className="text-gray-950">
        <GuildCtaSheet
          target="_blank"
          showSheet={isSheetOpen}
          onClose={onCloseSheet}
          projectSlug={projectSlug}
          guid={guid}
        />
      </div>
    </>
  )
}
